// 権限制御関連のMixin
import constOperationAuthority from "../../definition/const/const_operation_authority";

export default {
    computed: {
        authorityId: function () {
            return this.getAuthorityId(this.$router.currentRoute.meta.pageId);
        },
        hasCareerEditAuthority: function () {
            //TODO:職務経歴が表示されない不具合が発生することの暫定対策。
            //詳細：InputItems内の階層がページによって異なるため、hasEditAuthority呼び出しの第三引数がundifinedになりエラーが発生する。
            //その為、hasEditAuthority関数呼び出し前にinputitemsの中身がundefinedか確認をする処理を追加。
            //今後実施予定のauthorityControl.jsの共通化対応にてチェック対象の変数が統一されるため本不具合は根本解決予定。
            if (typeof this.inputItems === "undefined" ||
                typeof this.inputItems.user_id === "undefined") {
                return false;
            }
            return this.hasEditAuthority(this.authorityId,this.inputItems.organization_id,this.inputItems.m_position.position_number);
        },
    },
    methods: {
        // ログインユーザーが持つ対象画面ID（引数）の権限情報を取得
        getAuthorityId: function (pageId) {
            return this.$store.state.loginUser.p_authorities.find(
                (a) => a.page_id === pageId
            ).operation_authority;
        },
        // 部下（自分の所属（配下含む）かつ役職優位番号が下のユーザー）かどうかの判定
        isSubordinate: function (organizationId, positionNumber) {
            // ログインユーザーの所属ID
            const loginUserOrganizationId = this.$store.state.loginUser
                .organization_id;
            // ログインユーザーの役職優位番号
            const loginUserPositionNumber = this.$store.state.loginUser.m_position
                .position_number;
            return organizationId.indexOf(loginUserOrganizationId) === 0
                && positionNumber < loginUserPositionNumber
        },
        hasEditAuthority: function(authorityId, organization_id , position_number) {
            if (typeof this.inputItems === "undefined" ||
            typeof this.inputItems.user_id === "undefined") {
            return false;
        }
        const isTargetMe =
            this.inputItems.user_id === this.$store.state.loginUser.user_id;
        if (authorityId === constOperationAuthority.EDIT_ALL) {
            return true;
        } else if (authorityId === constOperationAuthority.EDIT_SUBORDINATE) {
            // 「自分の所属（配下含む）かつ役職が下のユーザー」＋「自分」で絞り込む
            return (
                this.isSubordinate(
                    organization_id,
                    position_number
                ) || isTargetMe
            );
        } else if (authorityId === constOperationAuthority.EDIT_SELF) {
            return isTargetMe;
        }
        return false;

        }
    },
}